<div>
  <div edsFlexbox justifyContent="space-between">
    <eds-title
      edsSpacing="sm"
      title="{{ 'literature.lit-cart-summary-title' | translate }}"
      size="h6"
      theme="basic"
    ></eds-title>
    <eds-link-item
      edsSpacing="md"
      title="{{ 'literature.lit-cart-summary-edit' | translate }}"
      [href]="myCartLink"
    ></eds-link-item>
  </div>
  <div edsSpacing="md">
    <eds-sidebar [closeButton]="true" [divider]="false" [hasPadding]="false">
      <ng-container *ngIf="cartState$ | async as cartState">
        <div *ngFor="let item of cartState.cartItems; let i = index">
          <a
            edsPadding
            edsPaddingAll="md"
            [href]="getLiteratureDetailLink(item.docId)"
            class="text-decoration-none sidebar__list-item text-black"
            edsFlexbox
            alignItems="flex-start"
            justifyContent="space-between"
          >
            <div edsPadding edsPaddingRight="sm">
              <p>{{ item.fundName }}</p>
              <p edsSpacing="none">Qty: {{ item.quantity }}</p>
            </div>
            <eds-icon
              class="text-primary"
              size="small"
              type="carrot-right"
              aria-hidden="true"
            >
            </eds-icon>
          </a>
          <eds-divider *ngIf="i < cartState.cartItems.length - 1"></eds-divider>
        </div>
      </ng-container>
    </eds-sidebar>
  </div>
  <eds-sidebar [closeButton]="true" [divider]="false" [hasPadding]="false">
    <div edsPadding edsPaddingAll="md">
      <p>{{ "literature.lit-cart-summary-need-help" | translate }}</p>
      <p edsSpacing="none">
        {{ "literature.lit-cart-summary-call" | translate }}
      </p>
    </div>
  </eds-sidebar>
</div>
